<template>
  <button type="button" class="k-primary k-button k-grid-edit-command" @click="editHandler">
    <span class="icon icon-edit"></span>
  </button>
</template>

<script>
export default {
  methods: {
    editHandler() {
      this.$emit('edit', { dataItem: this.dataItem });
    }
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String
  }
};
</script>
